// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}